import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";


export const fetchServiceOptions = async ({ onSuccess, onError }) => {
    try {
        const response = await fetch(
            `${BACKEND_API_URL}/service-option`,
            { method: "GET" },
        );

        const data = await handleApiResponse(response, "fetchServiceOptions");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const createServiceOption = async ({ auth, payload, onSuccess, onError }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/service-option`,
            { method: "POST", body: JSON.stringify(payload) },
            auth
        );

        const data = await handleApiResponse(response, "createServiceOption");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const updateServiceOption = async ({ auth, serviceOptionId, payload, onSuccess, onError }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/service-option/${serviceOptionId}`,
            { method: "PUT", body: JSON.stringify(payload) },
            auth
        );

        const data = await handleApiResponse(response, "updateServiceOption");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};

export const deleteServiceOption = async ({ auth, serviceOptionId, onSuccess, onError }) => {
    try {
        const response = await fetchWithAuth(
            `${BACKEND_API_URL}/service-option/${serviceOptionId}`,
            { method: "DELETE" },
            auth
        );

        const data = await handleApiResponse(response, "deleteServiceOption");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};
